import {booleanAttribute, Component, computed, input} from '@angular/core';
import {customerColor, customerInk} from '../../customer-color';

/**
 * "Klant › project › taak": the customer in bold, the rest grey. The dot color comes from
 * `customerColor(companyId)`; with `colored` the customer name uses that color too (darkened when it is light).
 */
@Component({
    selector: 'app-client-path',
    templateUrl: './client-path.component.html',
    styleUrl: './client-path.component.scss',
    host: {
        '[class.small]': 'size() === "sm"'
    }
})
export class ClientPathComponent {
    readonly client = input<string>('');
    readonly path = input<string | (string | null | undefined)[]>([]);
    readonly companyId = input<number | string | null>(null);
    readonly dot = input(true, {transform: booleanAttribute});
    readonly colored = input(false, {transform: booleanAttribute});
    readonly size = input<'sm' | 'md'>('md');

    readonly color = computed(() => customerColor(this.companyId()));
    readonly ink = computed(() => customerInk(this.companyId()));
    readonly rest = computed(() => {
        const path = this.path();
        return (Array.isArray(path) ? path : [path]).filter(part => !!part).map(part => ` › ${part}`).join('');
    });
}
